import Typography from "@/components/atoms/typography";
import React from "react";

const Heading = ({ content }: { content: string }) => {
    return (
        <Typography className="sm:!text-28 !text-20 sm:!leading-[33.89px] !leading-6 text-black !font-semibold">
            {content}
        </Typography>
    )
}

export default Heading